import { t } from 'i18next';
import { ArrowLeft } from '@peacecover/icon';
import { useHandleHistoryBack } from '@pocapan/shared/utils/useHandleHistoryBack';
import NotificationBadge from './NotificationBadge';

const MyPageHeader = () => {
  const handleHistoryBack = useHandleHistoryBack();

  return (
    <header className="py-[11px] flex items-center justify-between">
      <div className="flex items-center gap-[10px]">
        <button
          type="button"
          aria-label="뒤로가기"
          onClick={handleHistoryBack}
          className="flex h-[24px] w-[24px] items-center justify-center"
        >
          <ArrowLeft size={24} className="text-text-main-lv1" />
        </button>
        <h1 className="text-[26px] font-bold text-main-light-1 dark:text-main-dark-1">
          {t('myPage.pageName')}
        </h1>
      </div>
      <NotificationBadge />
    </header>
  );
};

export default MyPageHeader;
